<template>
    <ol :class="breadcrumbsClass">
        <li v-for="(breadcrumb, index) in breadcrumbs" :key="index" class="breadcrumbs__breadcrumb">
            <router-link v-if="breadcrumb.route" :to="breadcrumb.route">
                {{ breadcrumb.label }}
            </router-link>
            <span v-else>
                {{ breadcrumb.label }}
            </span>
        </li>
    </ol>
</template>

<script>
    export default {
        props: {
            breadcrumbs: { type: Array, required: true },
            isHidden: { type: Boolean, default: false },
        },

        computed: {
            breadcrumbsClass() {
                return {
                    breadcrumbs: true,
                    'breadcrumbs--is-hidden': this.isHidden,
                }
            },
        },
    }
</script>
